import WishListPage from "./WishListPage";
export default WishListPage;